/// <amd-module name="Wit/Common/TeamSettingsPanel/Components/TeamSettingsPanel" />
import * as React from "react";
import { Components, IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import * as Resources from "Wit/Common/TeamSettingsPanel/Resources";
import { WitSettingsPanel } from "Wit/Common/WitSettingsPanel/Components/WitSettingsPanel";
import { ISettingsView, IWitSettingsPanelProps } from "Wit/Common/WitSettingsPanelTypes/Components/WitSettingsPanel.props";
import { getTeamSettingsPanelService } from "../Services/TeamSettingsPanelService";
import { TeamSettingsGeneralTab } from "./TeamSettingsGeneralTab";
import { ITeamSettingsPanelProps } from "./TeamSettingsPanel.Props";

export class TeamSettingsPanel extends VssComponent<ITeamSettingsPanelProps> {
    private tabs: ISettingsView[] = [];

    constructor(props: ITeamSettingsPanelProps, context: IVssComponentContext) {
        super(props, context);
        const { settingsViews } = props;
        const teamSettingsPanelService = getTeamSettingsPanelService(context.pageContext);

        const generalTab: ISettingsView = {
            name: Resources.General,
            renderContent: () => <TeamSettingsGeneralTab teamId={props.teamId} />,
            isDirty: teamSettingsPanelService.getIsDirty(),
            isValid: teamSettingsPanelService.getIsValid()
        };

        settingsViews && this.tabs.push(...settingsViews);
        this.tabs.push(generalTab);
    }

    public render = (): JSX.Element => {
        const props: IWitSettingsPanelProps = {
            ...this.props,

            // these need to go after to overwrite passed in props
            onSave: this.onSave,
            settingsViews: this.tabs,
            titleProps: this.props.titleProps || { text: Resources.TeamSettings }
        };
        return <WitSettingsPanel {...props} />;
    };

    private onSave = async () => {
        const updateSettingsSuccess = await getTeamSettingsPanelService(this.context.pageContext).updateTeamSettings(this.props.teamId);

        if (this.props.onSave && updateSettingsSuccess) {
            return await this.props.onSave();
        }

        return updateSettingsSuccess;
    };
}

Components.add("ms.vss-work-web.team-settings-panel-component", TeamSettingsPanel);
